import { sandboxAttachmentBlobQuery } from "@common/api"
import { LoadingState } from "@common/components/shared/loading-state"
import { createFileRoute } from "@tanstack/react-router"
import { Suspense, useMemo } from "react"
import { decodeSourceEvidence, sourceSearchSchema } from "@/lib/source-evidence"
import { SandboxFileViewer } from "./-components/sandbox-file-viewer"

export const Route = createFileRoute(
  "/_layout/trace/sandbox/$conversationSessionId/$",
)({
  validateSearch: (search) => sourceSearchSchema.parse(search),
  loader: ({ context: { queryClient }, params }) => {
    queryClient.ensureQueryData(
      sandboxAttachmentBlobQuery({
        conversationSessionId: params.conversationSessionId,
        filePath: params._splat ?? "",
      }),
    )
    const filePath = params._splat ?? ""
    return { breadcrumb: filePath.split("/").pop() ?? filePath }
  },
  component: SandboxAttachmentPage,
})

function SandboxAttachmentPage(): React.ReactElement {
  const { conversationSessionId, _splat } = Route.useParams()
  const { page, source } = Route.useSearch()
  const sourceEvidence = useMemo(() => decodeSourceEvidence(source), [source])

  return (
    <Suspense fallback={<LoadingState />}>
      <SandboxFileViewer
        conversationSessionId={conversationSessionId}
        filePath={_splat ?? ""}
        page={page}
        sourceEvidence={sourceEvidence}
      />
    </Suspense>
  )
}
